import { useEffect } from 'react';

const SITE = {
  name: 'Waypoint Transformation LLC',
  url: 'https://www.waypointtransformation.com',
  defaultTitle: 'Waypoint Transformation | Chicago-Based Fractional CIO, CTO & Global Transformation Leadership',
  defaultDescription: 'Chicago-based technology consulting firm delivering fractional CIO, CTO, engineering and technical leadership, program management, and global transformation. Local expertise; global reach across six continents.',
  defaultImage: 'https://www.waypointtransformation.com/downloads/waypoint-logo-full-onwhite.svg',
};

function setMeta(selector, attr, value) {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [type, name] = selector.replace(/[\[\]"]/g, '').split('=');
    el.setAttribute(type, name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function applyCoreMeta({ pageTitle, pageDesc, canonical, noindex }) {
  document.title = pageTitle;
  setMeta('meta[name="description"]', 'content', pageDesc);
  setMeta('meta[name="robots"]', 'content', noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large');
  setLink('canonical', canonical);
}

function applySocialMeta({ pageTitle, pageDesc, canonical, ogImage, type }) {
  setMeta('meta[property="og:title"]', 'content', pageTitle);
  setMeta('meta[property="og:description"]', 'content', pageDesc);
  setMeta('meta[property="og:url"]', 'content', canonical);
  setMeta('meta[property="og:type"]', 'content', type);
  setMeta('meta[property="og:image"]', 'content', ogImage);
  setMeta('meta[property="og:site_name"]', 'content', SITE.name);

  setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
  setMeta('meta[name="twitter:title"]', 'content', pageTitle);
  setMeta('meta[name="twitter:description"]', 'content', pageDesc);
  setMeta('meta[name="twitter:image"]', 'content', ogImage);
}

export default function usePageMeta({ title, description, path = '/', image, type = 'website', noindex = false } = {}) {
  const pageTitle = title ? `${title} | ${SITE.name}` : SITE.defaultTitle;
  const pageDesc = description || SITE.defaultDescription;
  const canonical = `${SITE.url}${path}`;
  const ogImage = image || SITE.defaultImage;

  useEffect(() => {
    applyCoreMeta({ pageTitle, pageDesc, canonical, noindex });
  }, [pageTitle, pageDesc, canonical, noindex]);

  useEffect(() => {
    applySocialMeta({ pageTitle, pageDesc, canonical, ogImage, type });
  }, [pageTitle, pageDesc, canonical, ogImage, type]);
}

export { SITE };
